import { TemplateMeasure } from "../bundles/entities.bundle";

export class ViewTemplateDetails {
    templateId: number;
    templateTitle: string;
    description: string;
    templateTag: string;
    templateVersion: string;
    payerId: number;
    payerName: string;
    formatId: number;
    formatName: string;
    customReportId: number;
    customReportName: string;
    startDate: string;
    endDate: string;
    riskTypeId: number;
    riskTypeName: string;
    isPublished: boolean;
    measures: Array<TemplateMeasure>;
    collapse: boolean;
}